import { render, staticRenderFns } from "./SuperAdminLogin.vue?vue&type=template&id=563235cc&scoped=true&"
import script from "./SuperAdminLogin.vue?vue&type=script&lang=js&"
export * from "./SuperAdminLogin.vue?vue&type=script&lang=js&"
import style0 from "./SuperAdminLogin.vue?vue&type=style&index=0&id=563235cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "563235cc",
  null
  
)

export default component.exports